export default __webpack_public_path__ + "0d208b78d81461f44db5f186d0b968ef.png";